import styled from 'styled-components'
import Icon from './Icons'

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  border-radius: 100px;
  width: 100%;
  box-sizing: border-box;

  & > button {
    flex-shrink: 0;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 30px;
    
    > input {
      width: 300px;
    }

    > button {
      width: 100%;
    }
  }
}
`
export const SearchWrapperIcon = styled.div`
  flex-shrink: 0;
  top: 12px;
  position: relative;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 600px) {
    display: none;
  }
`

export const SearchInputLabel = styled.span<{ text: string }>`
  content: '${({ text }) => text}';
  // position: absolute;
  top: -28px;
  left: 0;
  font-size: 17px;
  display: block;
`
export const InputContain = styled.div`
  width: calc(100% / 3);
  position: relative;
  transition: 0.2s ease-in-out;
  box-sizing: border-box;

  &:before {
    content: 'Location';
    position: absolute;
    top: -15px;
    left: 44px;
    font-size: 13px;
    display: block;
  }

  @media (max-width: 600px) {
    width: 100%;

    &:before {
      font-size: 17px;
      position: static;
      margin-bottom: 12px;
    }
  }
`

export const IconSvg = styled(Icon)`
  position: absolute;
  top: 50px;
  left: 20px;
  display: none;

  @media (max-width: 600px) {
    display: block;
  }
`

export const CloseSvg = styled(Icon)`
  position: absolute;
  top: 6px;
  right: 21px;
  cursor: pointer;
  fill: #ababab;

  &:hover {
    fill: #707070;
  }

  @media (max-width: 600px) {
    display: block;
    position: absolute;
    top: 54px;
    right: 20px;
    cursor: pointer;
  }
`

export const LocationInput = styled(InputContain)`
  &:before {
    content: 'Location';
  }
`

export const ExperienceInput = styled(InputContain)`
  &:before {
    content: 'Experience';
  }
  @media (min-width: 601px) {
    border-left: 1px solid var(--grey-25);
    border-right: 1px solid var(--grey-25);
  }
`

export const DateInput = styled(InputContain)`
  &:before {
    content: 'Date';
  }

  & input {
  }
`

export const SearchWrapperInputs = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  div > input {
    border: none;
    transition: 0.2s ease-in-out;
    height: 24px;
    padding: 0;
    border-radius: 0;
    font-size: 16px;
    width: 100%;
    font-weight: var(--font-regular);
    padding-left: 44px;
    padding-right: 44px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;

    @media (min-width: 601px) {
      &:focus {
        outline: none;
        border: none;
        flex-shrink: 0;
      }
    }

    &::placeholder {
      color: #b5bac4;
    }
  }

  @media (min-width: 601px) {
    position: relative;
    top: 22px;
    width: calc(100% - 22px - 100px);
  }

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: 100%;
    gap: 30px;

    div > input {
      width: 100%;
      text-align: left;
      padding: 20px;
      height: auto;
      border: 1px solid var(--grey-25);
      border-radius: 50px;
      padding-left: 54px;
    }
  }
`

export const SearchSuggestionsWrap = styled.div`
  padding: 42px 0 20px 0;
  box-sizing: border-box;
  width: 100%;

  p {
    margin-bottom: 16px;
  }
  button {
    font-size: 14px;
    padding: 15px 12px;
    line-height: 1;
  }

  @media (min-width: 601px) {
    position: relative;
    left: -24px;
    width: calc(100% + 24px + 100px);
  }

  @media (max-width: 600px) {
    border: 2px solid var(--brand-secondary);
    border-radius: 0 0 30px 30px;
    border-top: 0;
    margin: 0;
    position: relative;
    top: -30px;
  }
`

export const SearchDatePicker = styled.div`
  margin-top: 42px;

  @media (min-width: 601px) {
    position: relative;
    left: 40px;
    width: 100%;
  }
  @media (max-width: 600px) {
    border: 2px solid var(--brand-secondary);
    border-radius: 0 0 30px 30px;
    border-top: 0;
    margin: 0;
    position: relative;
    top: -30px;
  }
`

export const DateButtonWrapper = styled.div`
  display: none;
  text-align: center;

  button {
    width: 90%;
    margin: 0 auto;
  }

  @media (max-width: 600px) {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
`

export const Text = styled.p`
  font-size: 12px;
`

export const Heading = styled.p`
  font-weight: var(--font-bold);
  font-size: 12px;
`

export const Pill = styled.div`
  display: inline-block;
  border-radius: 32px;
  padding: 10px;
  background-color: white;
  border: 1px solid black;
  color: black;
`

export const Divider = styled.div`
  border-top: 1px solid #d9d9d9;
`

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  gap: 10px;

  & > div {
    cursor: pointer;
  }

  .all-btn {
    width: 60px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;

    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const ResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const SuggestedResult = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: var(--font-regular);
  font-size: 16px;
  padding: 10px;

  &:hover {
    background-color: lightgrey;
    border-radius: 15px;
  }
`

export const ResultsContainer = styled.div`
  padding: 42px 0 20px 0;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-start;
  flex-direction: column;
  gap: 16px;
  
  svg {
    position: relative;
    top: -4px;
    
    path {
      fill: var(--brand-secondary);
    }
  }

  @media (min-width: 601px) {
    position: relative;
    left: -24px;
  }

  @media (max-width: 600px) {
    border: 2px solid var(--brand-secondary);
    border-radius: 0 0 30px 30px;
    border-top: 0;
    margin: 0;
    position: relative;
    top: -30px;
  }
`

export const Result = styled.p`
  display: flex;
  gap: 16px;
  cursor: pointer;

  &:hover {
    svg path {
      fill: var(--brand-primary);
    }
  }
`

export const ArrowButton = styled.button`
  border-radius: 64px;
  margin-top: 100px;
  width: 50px;
  height: 50px;
  background-color: white;
  border: 0;
  cursor: pointer;

  & > svg {
    margin-top: 3px;
  }
`

export const DatePickerWrapper = styled.div`
  .react-datepicker__month-container {
    width: 290px;
  }

  .react-datepicker__header {
    border: none;
    font-weight: var(--font-bold);
    background-color: white;
  }

  .react-datepicker__day-names {
    margin-top: 16px;
    font-size: 12px;
  }

  .react-datepicker__day {
    font-weight: var(--font-bold);
    margin-bottom: 6px;
  }

  .react-datepicker__day--highlighted,
  .react-datepicker__day--range-start,
  .react-datepicker__day--in-selecting-range {
    background-color: #fac53226;
    color: black;
    margin: 0;
    margin-bottom: 6px;
    border-radius: 0;
    padding: 2.656px;
  }

  .react-datepicker__day--in-range {
    background-color: #fac53226;
    color: black;
    margin: 0;
    margin-bottom: 6px;
    border-radius: 0;
    padding: 2.656px;
  }

  .react-datepicker__day--highlighted:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .react-datepicker__day--highlighted:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .react-datepicker__month-container {
    background-color: transparent;
  }

  .react-datepicker__day--outside-month:not([aria-disabled='true']) {
    color: #868686;
    background: transparent;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--outside-month) {
    border-radius: 25px;
    background-color: #fac532;
    color: black;

    &[aria-selected='false'] {
      background-color: transparent;
    }
  }
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    font-weight: normal;
  }

  > span {
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-size: 17px;
    font-weight: var(--font-bold);
  }

  @media (max-width: 600px) {
    padding: 10px;
    border: 1px solid var(--grey-25);
    border-radius: 16px;

    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      width: 2.4rem;
      line-height: 2rem;
    }
  }
`

export const Calendar = styled.div`
  border: none;
  background-color: white;
  font-size: 14px;
  font-weight: var(--font-regular);

  @media (max-width: 600px) {
    font-size: 16px;
  }
`

export const DatePickerWrap = styled.div`
  display: flex;
  justify-content: space-around;

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: minmax(0, 50%) minmax(0, 50%);
    row-gap: 20px;

    > button:first-of-type {
      margin: 0 10px 0 auto;
      grid-row-start: 1;
      grid-row-end: span 1;
    }
    > button:last-of-type {
      margin: 0 auto 0 10px;
      grid-row-start: 1;
      grid-row-end: span 1;
      grid-column-start: 2;
    }
    > div {
      grid-column-end: span 2;

      .react-datepicker,
      .react-datepicker__month-container {
        width: 100%;
      }
    }
  }
`

export const ModalHeader = styled.div`
  justify-content: space-between;
  flex-shrink: 0;
  align-items: center;
  background: var(--brand-secondary);
  height: 54px;
  color: white;
  padding: 0 24px;
  font-weight: var(--font-medium);
  font-size: 16px;
  display: none;

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    fill: white;
  }

  @media (max-width: 600px) {
    display: flex;
  }
`

export const ButtonWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;

  button {
    padding: 15px 12px;
    font-size: 12px;
    font-weight: var(--font-bold);
    width: 100px;
  }

  @media (max-width: 600px) {
    padding-top: 20px;
    width: calc(100% - 40px);
    margin: 0 auto;

    button {
      flex-grow: 1;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 26px 32px 26px 32px;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 601px) {
    &.location-active {
      ${LocationInput} {
        width: calc(100% - calc(175px * 2));
      }
      ${ExperienceInput},
      ${DateInput} {
        width: 175px;
      }
    }
    &.experience-active {
      ${LocationInput},
      ${DateInput} {
        width: 175px;
      }
      ${ExperienceInput} {
        width: calc(100% - calc(175px * 2));
      }
    }
    &.date-active {
      ${LocationInput},
      ${ExperienceInput} {
        width: 175px;
      }
      ${DateInput} {
        width: calc(100% - calc(175px * 2));
      }
    }
  }

  @media (max-width: 768px) {
    overflow: auto;
    padding: 20px;
    margin: 0;
    width: 100%;
  }

  @media (max-width: 600px) {
    position: relative;
    border: 2px solid transparent;

    &:before {
      content: '';
      position: absolute;
      top: -28px;
      left: 0;
      font-size: 17px;
      display: block;
    }

    ${SearchWrapperInputs} input {
      transition: 0.15s ease-in-out;
      background: transparent;
    }

    &.location-active,
    &.experience-active,
    &.date-active {
      ${ResultsContainer},
      ${DatePickerWrap},
      ${SearchSuggestionsWrap} {
        padding: 12px;
      }
    }

    &.location-active .location-search-input,
    &.experience-active .exp-search-input,
    &.date-active .date-search-input {
      border-color: transparent;
    }

    &.location-active {
      ${SearchSuggestionsWrap},
      ${ResultsContainer} {
        grid-row-start: 2;
      }
      ${LocationInput} {
        &:after {
          content: '';
          display: block;
          width: 100%;
          box-sizing: border-box;
          height: calc(100% - 29px);
          top: 29px;
          left: 0;
          border: 2px solid var(--brand-secondary);
          border-radius: 30px 30px 0 0;
          border-bottom: 0;
          position: absolute;
          pointer-events: none;
        }
      }
    }
    &.experience-active {
      ${SearchSuggestionsWrap},
      ${ResultsContainer} {
        grid-row-start: 3;
      }
      ${ExperienceInput} {
        &:after {
          content: '';
          display: block;
          width: 100%;
          box-sizing: border-box;
          height: calc(100% - 29px);
          top: 29px;
          left: 0;
          border: 2px solid var(--brand-secondary);
          border-radius: 30px 30px 0 0;
          border-bottom: 0;
          position: absolute;
          pointer-events: none;
        }
      }
    }
    &.date-active {
      ${SearchSuggestionsWrap},
      ${ResultsContainer} {
        grid-row-start: 4;
      }
      ${DateInput} {
        &:after {
          content: '';
          display: block;
          width: 100%;
          box-sizing: border-box;
          height: calc(100% - 29px);
          top: 29px;
          left: 0;
          border: 2px solid var(--brand-secondary);
          border-radius: 30px 30px 0 0;
          border-bottom: 0;
          position: absolute;
          pointer-events: none;
        }
      }
    }
  }
`
